// extracted by mini-css-extract-plugin
export default {"root":"style_root__GPI73","empty":"style_empty__ktDWb"};